import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from '@services/index';
import { AlertService } from '@services/utils/alerts/alert.service';
import { first } from 'rxjs';
import { Storage } from '@ionic/storage-angular';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.page.html',
  styleUrls: ['./consent.page.scss']
})
export class ConsentPage implements OnInit {
  @Input() id: boolean;
  country: string = 'es_Ar'
  constructor(
    public modalController: ModalController,
    public alertService: AlertService,
    public authService: AuthService,
    public storage: Storage,
  ) { }
  public storage_user: Storage | null = null

  ngOnInit() {
    this.country = localStorage.getItem('country')
   }

  async openAlert() {
    this.alertService.disclaimerValidatePersonalData().then((e) => {
      console.log(e)
      if(e == false)
      {
        this.closeModal()
      }
    })
  }

  async submit() {
    console.log('submit')
    this.authService
      .acceptPersonalData(this.id)
      .pipe(first())
      .subscribe(
        (res) => {
          if(res.payload.data.id == this.id)
          {
            this.modalController.dismiss(true)
          }
          else
          {
            this.error(res)
          }
        },
        (err) => {
          this.alertService.dismiss().then(() => {
            this.error(err)
          })
        }
      )
  }

  error(error) {
    const subHeader = 'Error con la aceptación del Consentimiento Informado!'
    const message = 'No se pudo aceptar el Consentimiento Informado, por favor intente nuevamente.'
    console.log(error)
    this.alertService.statusAlert(subHeader, message)
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
